import { t } from 'i18next';

import { useEffect, useState } from 'react';
import CustomToolTip from '../../core/CustomToolTip/CustomToolTip';
import VideoComponent from '../../core/Video/VideoAnimation';
import { IconBack, IconCircleInfo, IconNext, IconPack } from '../Icons';

import { useRemainingPacks } from '../../hooks/useRemainingPacks';
import IconPro from '../Icons/IconPro';
import CircularLoading from '../../shared/CircularLoading/CircularLoading';

export const PriceComparatorPackSelector = ({
	setCurrentStep,
	setCurrentPack,
}: {
	setCurrentStep: (step: string) => void;
	setCurrentPack: (pack: { userSubscriptionId: string; productCount?: number; countryCount?: number }) => void;
}) => {
	const [selectedPack, setSelectedPack] = useState<string | null>(null);

	const {
		data: remainingPacks,
		loading: loadingCalcs,
		error: errorCalcs,
		refetch: refetchRemainingCalcs,
	} = useRemainingPacks(process.env.REACT_APP_PRICE_COMPARATOR_ID || '354');

	const availablePacks = remainingPacks?.results?.filter((pack) => (pack.remainingUses ?? 0) > 0) || [];

	const handlePackClick = (pack: { userSubscriptionId: string; productCount?: number; countryCount?: number }) => {
		setSelectedPack(pack.userSubscriptionId);
		setCurrentPack(pack);
	};

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	if (loadingCalcs) {
		return <CircularLoading />;
	}

	return (
		<>
			<div className="price-comp__row">
				<div className="exporter-test-information__header">
					<div className="price-calc__principal-title">
						<span>{t('price_comparator.header.title')}</span>
						<CustomToolTip
							title=""
							tooltipText={
								<span>
									{t('price_comparator.header.tooltip')}{' '}
									<button
										// onClick={handleClickOpen}
										className="price-calc__tootip-link">
										{t('price_comparator.header.button')}
									</button>
								</span>
							}>
							<IconCircleInfo />
						</CustomToolTip>
						{(remainingPacks?.availableSubscriptionsCount ?? 0) > 0 ? (
							<span className="price-calc__label price-calc__label--pro">
								<IconPro
									fill="#1A2228"
									height={12}
									width={15}
								/>
								<span className="price-calc__label__text">
									{remainingPacks?.availableSubscriptionsCount}{' '}
									{(remainingPacks?.availableSubscriptionsCount ?? 0) === 1
										? t('price_comparator.step_saved.pack_available')
										: t('price_comparator.step_saved.packs_available')}
								</span>
							</span>
						) : (
							<span className="price-calc__label">
								<span className="price-calc__label__text">{t('price_comparator.step_saved.pack_name')}</span>
							</span>
						)}
					</div>
				</div>
			</div>
			<div className="price-comp__row">
				<div className="price-comp__flex">
					<div className="price-comp__main">
						<div className="price-comp__head">
							<button
								type="button"
								className="price-comp__back"
								onClick={() => setCurrentStep('saved')}>
								<IconBack />
							</button>
						</div>
						<div className="price-comp__body">
							<h3 className="price-comp__body__title">{t('price_comparator.step_pack_selector.title')}</h3>
							<div className="price-comp__packs">
								{availablePacks.map((pack) => (
									<button
										className={`price-comp__pack ${selectedPack === pack.userSubscriptionId ? 'active' : ''}`}
										onClick={() =>
											handlePackClick({
												userSubscriptionId: pack.userSubscriptionId,
												productCount: pack.productCount,
												countryCount: pack.countryCount,
											})
										}>
										<div className="price-comp__pack__left">
											<div className="price-comp__pack__icon">
												<IconPack fill="#2E3C46" />
											</div>
											<div className="price-comp__pack__title">{pack.name}</div>
										</div>
										<div className="price-comp__pack__right">
											<p className="price-comp__pack__description">{pack.productDetail} </p>
										</div>
									</button>
								))}
							</div>
						</div>
						<div className="price-comp__footer">
							<button
								type="button"
								className="price-comp__footer__legal">
								{t('price_comparator.step_pack_selector.legal')}
							</button>
							<button
								type="button"
								className={`price-comp__footer__next ${!selectedPack ? 'disabled' : ''}`}
								disabled={!selectedPack}
								onClick={() => setCurrentStep('detail')}>
								{t('price_comparator.step_pack_selector.button')}
								<IconNext
									className="price-comp__next-icon"
									fill="#1A2228"
								/>
							</button>
						</div>
					</div>
				</div>
				<div className="price-comp__fixed">
					<VideoComponent
						showSrcImage={true}
						urlImagen={null}
					/>
				</div>
			</div>
		</>
	);
};
